import loadable from '@loadable/component';

import './PublicTrip.css';

export default loadable(() => {
  return import('./PublicTrip.jsx');
});
